import React, { ReactElement } from 'react'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'

type Instructor = {
  id: string
  name: string
  credentials?: string
}

type Props = {
  instructors: Instructor[]
  selectedID: string
  onChange: (id: string) => void
}

export default function ViewingScheduleAsDropdown({
  instructors,
  selectedID,
  onChange,
}: Props): ReactElement {
  return (
    <FormControl size="small" sx={{ minWidth: 220 }}>
      <InputLabel id="viewing-schedule-as-label">
        Viewing schedule as
      </InputLabel>
      <Select
        labelId="viewing-schedule-as-label"
        value={selectedID}
        label="Viewing schedule as"
        onChange={(e: SelectChangeEvent<string>) => onChange(e.target.value)}
      >
        {instructors.map((i) => (
          <MenuItem key={i.id} value={i.id}>
            {i.credentials ? `${i.name} (${i.credentials})` : i.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
